import { Container, Grid } from "@material-ui/core"
import HomePage from "../../Home"
import { useParams } from "react-router-dom"
import { useDispatch } from "react-redux"
import { useEffect } from "react"
import { obtenerGruposClaveViajeAction } from "../../../ducks/aereosDuck"
import TGrupoAereo from "../TGrupoAereo"
const VGrupoAereo = () => {
    const { ClavePaquete } = useParams()
    const dispatch = useDispatch()
    useEffect(() => {
        dispatch(obtenerGruposClaveViajeAction({ claveViaje: ClavePaquete }))
    }, [dispatch, ClavePaquete])
    return (
        <HomePage>
            <Container>
                <Grid container>
                    <Grid item xs={12}>
                        <h3>Aereos</h3>
                    </Grid>
                    <Grid item xs={12}>
                        <TGrupoAereo />
                    </Grid>
                </Grid>
            </Container>
        </HomePage>
    )
}
export default VGrupoAereo